import React from 'react';

import 'scss/layout.scss';
import './index.scss';

export default function NoPendingContent(props) {
    return (
        <div className="layout-stack no-pending-content">
            <div className="no-pending-content__image">
                <div className="no-pending-content__image__circles" />
                <div className="no-pending-content__image__stars" />
            </div>
            <div className="no-pending-content__heading">You’re a rockstar!</div>
            <div className="no-pending-content__subheading">
                You’ve reviewed all pending content for this campaign.
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./components/no_pending_content/index.js